import React, { useState, useEffect } from "react";
import OffCanvas from "../common/offCanvas";
import strings from "../../Utils/strings";
import EditDoctorProfileView from "./editDoctorProfileView";
import EditDocNew from "./EditDocNew";
import utils from "../../Utils";
import Select from "react-select";
import DoctorTiming from "../manageClinic/doctorTiming/doctorTiming";
import { t } from "../../Utils/translate";

function EditDoctorProfile({ isClose, doctorId, isEditDoctorTiming , doctorInfo, refresh, setRefresh, isLangEn}) {

  const [doctorIdValue, setDoctorIdValue] = useState(null);

  useEffect(() => {
    setDoctorIdValue(doctorId ? doctorId : null)
  }, [doctorId]);


  const [offCanvasOpen, setOffCanvasOpen] = useState(false);
  const [doctorTimingCanvasOpen, setDoctorTimingCanvasOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);

  const handleClose = () => {
    setRefresh(!refresh)
    setOffCanvasOpen(false);
  };

  const handleIsClose = (data) => {
    isClose(data);
  };

  const handleDoctorTImingClose = () => {
    setDoctorTimingCanvasOpen(false);
  };

  const handleSelect = (selectedOption, value) => {
    if (selectedOption.value === strings.value.edit_profile) {
      setOffCanvasOpen(true);
    } else {
      setDoctorTimingCanvasOpen(true)
    }
  }

  const handleEditDoctorTiming = (data) => {
    isEditDoctorTiming(data);
  };


  return (
    <div>
      <div className="row">
        <Select
          isSearchable={false}
          placeholder={
            <div>
              <i className="ri-edit-2-line">
                <span className="edit">{t("btnEdit")}</span>
              </i>
            </div>
          }
          options={utils.constants.doctorEditList}
          styles={utils.appStyles.customDropDownStyles}
          onChange={handleSelect}
          value={selectedOption}
          menuPortalTarget={document.body}
        />
      </div>

      <OffCanvas
        show={offCanvasOpen}
        onHide={handleClose}
        title={t("labelDoctorProfile")}
      >
        <EditDocNew onClose={handleClose} doctorInfo={doctorInfo} isLangEn={isLangEn}/>
        {/* <EditDoctorProfileView onClose={handleClose} isClose={handleIsClose} doctorInfo={doctorInfo}/> */}
      </OffCanvas>
    </div>
  );
}

export default EditDoctorProfile;
